const PeopleStoriesComponent = () => {

    return(
        <p>People Stories here</p>
    )

}

export default PeopleStoriesComponent